var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.files
        ? _c(
            "base-card",
            {
              attrs: {
                overflowVisible: "",
                title: _vm.$t("documentsAndInformation"),
                hideButtons: _vm.historyReadOnly
              }
            },
            [
              _c("upload-file-select", { on: { refresh: _vm.refreshTable } }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-lg-7 col-12 p-1 mb-4" },
                [
                  _c("base-select", {
                    attrs: {
                      loading: _vm.tagSelect.loading,
                      options: _vm.tagSelect.options,
                      label: _vm.$i18nHelpers.normalizeProp("name"),
                      valueProp: "id",
                      placeholder: _vm.$t("filterByType"),
                      clearable: ""
                    },
                    model: {
                      value: _vm.tagSelect.filter,
                      callback: function($$v) {
                        _vm.$set(_vm.tagSelect, "filter", $$v)
                      },
                      expression: "tagSelect.filter"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("paginated-table", {
                attrs: {
                  fields: _vm.table.fields,
                  items: _vm.files,
                  "empty-text": _vm.$t("nofiles"),
                  filter: _vm.tagSelect.filter
                    ? "" + _vm.tagSelect.filter
                    : null,
                  filterFn: _vm.filterTableCategories,
                  stacked: _vm.stacked
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "cell(viewLink)",
                      fn: function(data) {
                        return [
                          data.item.link && !_vm.fileLocked(data)
                            ? _c(
                                "span",
                                {
                                  staticClass: "table-href",
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.accessLink(
                                        data.item.link,
                                        data.item.idHisEnlaces
                                      )
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("watch")))]
                              )
                            : _vm._e()
                        ]
                      }
                    },
                    !_vm.historyReadOnly
                      ? {
                          key: "cell(complete)",
                          fn: function(data) {
                            return [
                              _vm.showCompleteLink(data.item)
                                ? _c(
                                    "a",
                                    {
                                      attrs: { href: "#" },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.completeAction(data.item)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("complete")))]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.showCompletedTitle(data.item) &&
                              !_vm.fileLocked(data)
                                ? _c("span", {
                                    staticClass: "completed-title",
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.$t("completedHistory")
                                      )
                                    }
                                  })
                                : _vm._e()
                            ]
                          }
                        }
                      : null,
                    !_vm.historyReadOnly
                      ? {
                          key: "cell(preview)",
                          fn: function(data) {
                            return [
                              !data.item.idHisEnlaces &&
                              !_vm.fileLocked(data) &&
                              !data.item.readOnly
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "table-href",
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.getFiles(data.item.fileId)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("download-btn")))]
                                  )
                                : _vm._e()
                            ]
                          }
                        }
                      : null,
                    !_vm.historyReadOnly
                      ? {
                          key: "cell(lockStatus)",
                          fn: function(data) {
                            return [
                              _vm.$store.getters["session/userIsPatient"] &&
                              data.item.locked
                                ? _c("b-icon-lock-fill", {
                                    staticClass: "icon-locked",
                                    on: {
                                      click: function($event) {
                                        return _vm.modifyFileLocking(
                                          true,
                                          data.item
                                        )
                                      }
                                    }
                                  })
                                : _vm.$store.getters["session/userIsPatient"] &&
                                  !data.item.locked
                                ? _c("b-icon-unlock-fill", {
                                    staticClass: "icon-unlocked",
                                    on: {
                                      click: function($event) {
                                        return _vm.modifyFileLocking(
                                          false,
                                          data.item
                                        )
                                      }
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.$store.getters["session/userIsPatient"] &&
                              _vm.fileLocked(data)
                                ? _c("b-icon-lock-fill", {
                                    staticClass: "icon-locked",
                                    on: { click: _vm.showLockedMessage }
                                  })
                                : _vm._e()
                            ]
                          }
                        }
                      : null,
                    !_vm.historyReadOnly
                      ? {
                          key: "cell(remove)",
                          fn: function(data) {
                            return [
                              !_vm.fileLocked(data) &&
                              data.item.fileType != _vm.PRESCRIPTION_TYPE &&
                              data.item.fileType != _vm.REPORT_TYPE
                                ? _c("base-icon", {
                                    staticClass: "clickable",
                                    attrs: {
                                      src:
                                        "/static-appopensalud/img/icons/morillas-svg-icons/primary/remove.svg",
                                      color: _vm.RED_COLOUR
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.remove(data.item)
                                      }
                                    }
                                  })
                                : _vm._e()
                            ]
                          }
                        }
                      : null,
                    !_vm.historyReadOnly
                      ? {
                          key: "cell(actionsMobile)",
                          fn: function(data) {
                            return [
                              _vm.fileLocked(data)
                                ? _c("div", [
                                    _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$t("fileLockedByPatient")
                                        )
                                      }
                                    })
                                  ])
                                : _c("div", [
                                    data.item.link
                                      ? _c(
                                          "div",
                                          { staticClass: "stacked-item" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "table-href",
                                                on: {
                                                  click: function($event) {
                                                    $event.preventDefault()
                                                    return _vm.accessLink(
                                                      data.item.link,
                                                      data.item.idHisEnlaces
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("b-icon-eye", {
                                                  staticClass: "blue"
                                                })
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.showCompleteLink(data.item) ||
                                    _vm.showCompletedTitle(data.item)
                                      ? _c(
                                          "div",
                                          { staticClass: "stacked-item" },
                                          [
                                            _vm.showCompleteLink(data.item)
                                              ? _c(
                                                  "a",
                                                  {
                                                    attrs: { href: "#" },
                                                    on: {
                                                      click: function($event) {
                                                        $event.preventDefault()
                                                        return _vm.completeAction(
                                                          data.item
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("b-icon-pencil", {
                                                      staticClass: "blue"
                                                    })
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.showCompletedTitle(data.item)
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "completed-title"
                                                  },
                                                  [
                                                    _c("b-icon-check", {
                                                      staticClass: "blue"
                                                    })
                                                  ],
                                                  1
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !data.item.idHisEnlaces &&
                                    !data.item.readOnly
                                      ? _c(
                                          "div",
                                          { staticClass: "stacked-item" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "table-href",
                                                on: {
                                                  click: function($event) {
                                                    $event.preventDefault()
                                                    return _vm.getFiles(
                                                      data.item.fileId
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("b-icon-download", {
                                                  staticClass: "blue"
                                                })
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.$store.getters["session/userIsPatient"]
                                      ? _c(
                                          "div",
                                          { staticClass: "stacked-item" },
                                          [
                                            data.item.locked
                                              ? _c(
                                                  "span",
                                                  [
                                                    _c("b-icon-lock-fill", {
                                                      staticClass:
                                                        "icon-locked",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.modifyFileLocking(
                                                            true,
                                                            data.item
                                                          )
                                                        }
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              : !data.item.locked
                                              ? _c(
                                                  "span",
                                                  [
                                                    _c("b-icon-unlock-fill", {
                                                      staticClass:
                                                        "icon-unlocked",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.modifyFileLocking(
                                                            false,
                                                            data.item
                                                          )
                                                        }
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    data.item.fileType !=
                                      _vm.PRESCRIPTION_TYPE &&
                                    data.item.fileType != _vm.REPORT_TYPE
                                      ? _c(
                                          "div",
                                          { staticClass: "stacked-item" },
                                          [
                                            _c("base-icon", {
                                              staticClass: "clickable",
                                              attrs: {
                                                src:
                                                  "/static-appopensalud/img/icons/morillas-svg-icons/primary/remove.svg",
                                                color: _vm.RED_COLOUR
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.preventDefault()
                                                  return _vm.remove(data.item)
                                                }
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("hr")
                                  ])
                            ]
                          }
                        }
                      : null
                  ],
                  null,
                  true
                )
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "base-modal",
        {
          on: { hidden: _vm.resetCompleteModal },
          model: {
            value: _vm.showCompleteModal,
            callback: function($$v) {
              _vm.showCompleteModal = $$v
            },
            expression: "showCompleteModal"
          }
        },
        [
          _c("div", { staticClass: "text-center" }, [
            _vm.selectedCompleteFile.idHisEnlaces
              ? _c("div", [
                  _c("p", {
                    domProps: {
                      innerHTML: _vm._s(_vm.$t("mark-as-complete-text"))
                    }
                  })
                ])
              : _c(
                  "div",
                  [
                    _c("p", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t("history-files-overwrite-content")
                        )
                      }
                    }),
                    _vm._v(" "),
                    _c("b-form-file", {
                      staticClass: "col-lg-7 col-12 mt-2 mb-4",
                      attrs: {
                        placeholder: _vm.$t("select-or-drag-drop-file"),
                        "drop-placeholder": _vm.$t("drag-drop-file"),
                        "browse-text": _vm.$t("browse")
                      },
                      model: {
                        value: _vm.uploaderOverwrite.file,
                        callback: function($$v) {
                          _vm.$set(_vm.uploaderOverwrite, "file", $$v)
                        },
                        expression: "uploaderOverwrite.file"
                      }
                    }),
                    _vm._v(" "),
                    _c("p", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t("history-files-overwrite-question")
                        )
                      }
                    })
                  ],
                  1
                ),
            _vm._v(" "),
            _c(
              "div",
              [
                _c(
                  "base-button",
                  { staticClass: "mr-2", on: { click: _vm.completeFile } },
                  [_vm._v(_vm._s(_vm.$t("yes")))]
                ),
                _vm._v(" "),
                _c(
                  "base-button",
                  { attrs: { red: "" }, on: { click: _vm.resetCompleteModal } },
                  [_vm._v(_vm._s(_vm.$t("no")))]
                )
              ],
              1
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("base-dialog", {
        attrs: {
          content: _vm.lockDialogInfo.locking
            ? _vm.$t("lock-file-advice")
            : _vm.$t("unlock-file-advice"),
          okFn: function() {
            _vm.lockDialogInfo.locking ? _vm.lockFile() : _vm.unlockFile()
          },
          cancelFn: function() {
            _vm.lockDialogInfo.show = false
          }
        },
        model: {
          value: _vm.lockDialogInfo.show,
          callback: function($$v) {
            _vm.$set(_vm.lockDialogInfo, "show", $$v)
          },
          expression: "lockDialogInfo.show"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a83df30", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a83df30","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/HistoryFilesSection.vue
// module id = 2770
// module chunks = 31 34 64 147